export const UNDERLINE = '/_';
export const REGISTER = '/register';
export const LOGIN = '/login';
export const PASS_RECUPERATION = '/password-recuperation';
export const CORRETOR = '/corretor';
export const ACTIONSOLD = '/action/:playerId/:actionId/:now/:clientId';
export const ACTIONS = '/action/:playerId/:actionId/:clientId';
export const LANDING_BUSSINESS = '/landingBusiness/:playerId/:bussinessId';
export const FORGOT_PASSWORD = '/forgotPassword';
export const CONTACT_US = '/contactUs';
export const VERIFY = '/verify';
export const FORGOT_PASSWORD_PAGE = '/forgotpasswordInfluencerPlayer';
export const PASSWORD_EMAIL_RECOVERY_SENT = '/recoveryemailsent';
export const REGISTER_GAME_OF_INFLUENCERS = '/registergameinfluencers';
export const VALIDATION_CODE = '/validationCode';
export const UNSUBSCRIBE = '/Unsubscribe';
export const NOT_FOUND = '/not-found';

//! AUTH PROTECTED
export const START = '/';
export const CHECKOUT = '/checkout';
export const PAYMENT_LEAD = '/payment';
export const HOME = '/home';
export const EXTRACT = '/extract';
export const USER_INACTIVE = '/userInactive';
export const REGISTER_DETAILS = '/registerDetails';
export const DETAILS_INFLUENCER_PLAYER = '/detailsInfluencerPlayer';
export const CHOOSE_INFLUENCER = '/chooseInfluencer';
export const CONGRATULATIONS = '/congratulations';
export const NOTIFICATIONS = '/notifications';
export const MY_PROFILE = '/myProfile';
export const PROFILE = '/profile';
export const PROFILE_ACTIONS = '/profileActions';
export const MY_ACTIONS = '/myActions';
export const REDEEM_COINS = '/redeemCoins';
export const REDEEM_AWARDS = '/redeemAwards';
export const PROSPECTS = '/prospects';
export const ACTION_DETAILS = '/actionDetails';
export const QUIZ = '/quiz';
export const KEEPANEYE = '/keepAnEye';
export const ABOUT = '/about';
export const PLAYER_PROFILE = '/playerProfile';
export const INFOS = '/infos';
export const EDIT_PROFILE = '/editProfile';
export const PLAYER_QR_CODE = '/playerQrCode';
export const MY_INSTALLMENTS = '/myInstallments';
export const NF_UPLOAD = '/nfUpload';
export const MY_PURCHASES = '/myPurchases';
export const MY_RESCUES = '/myRescues';
export const MY_INDICATIONS = '/myIndications';
export const RESCUE_DETAILS = '/rescueDetails';
export const CART = '/cart';
export const RANKING = '/ranking';
export const CHANGE_PASSWORD = '/password';
export const ADDRESS = '/address';
export const EVOLUTION = '/notificationsevolution';
export const CONNECTION = '/notificationsconnection';
export const MY_ENGAGEMENTS = '/myEngagements';
export const MY_BENEFITS = '/myBenefits';
export const WELLCOME_INFLUENCER = '/wellcomeinfluencer';
export const FOLLOWERS = '/followers';
export const PROFILE_INFLUENCER = '/profileinfluencer';
export const PRIVATE = '/private';
export const RESULTS = '/results';
export const TERMS = '/terms';
export const CONFIRM_RESCUE = '/confirmRescue';
export const THANKS = '/thanks';
